<template>
    <div @contextmenu.prevent >
         <div v-if="maintMode"> 
            <video disablePictureInPicture autoplay muted loop id="maintvideo">
                <source src="embers-2.mp4" type="video/mp4">
            </video>
            <div class="maint-logo">
                <img onload="this.style.opacity='1';" class="big-logo" src="@/assets/img/Embers-Logo.png" alt="Embers Adrift">
            </div> 
            <div class="maint-text">
                Site is Down for Maintenance
            </div> 
        </div>
        <div v-else class="container-fluid">
            <div class="row">
                <!-- ============== HEADER =============== -->
                <header id="home">
                    <!-- Main nav -->
                    <nav class="navbar navbar-inverse navbar-custom navbar-fixed-top">
                        <div class="container">
                            <div class="navbar navbar-header">
                                <router-link class="navbar-brand navbar-logo" to="/"></router-link>
                                <b-button v-b-toggle.main-nav class="navbar-toggle custom-toggle-btn" @click="showMenu = !showMenu"> 
                                    <span class="sr-only">
                                        Toggle navigation
                                    </span>
                                    <span class="icon-bar"></span>
                                    <span class="icon-bar"></span>
                                    <span class="icon-bar"></span>
                                </b-button>
                            </div>
                            <b-collapse class="collapse navbar-collapse" v-model="showMenu" id="main-nav">
                                <ul class="nav navbar-nav navbar-right">
                                    <li class="plain-link dropdown"><a>The Game</a>
                                        <div class="dropdown-content">
                                            <router-link to="Roles" v-on:click.native="showMenu = !showMenu">Roles</router-link>
                                            <router-link to="Crafting" v-on:click.native="showMenu = !showMenu">Crafting</router-link>
                                            <router-link to="Gathering" v-on:click.native="showMenu = !showMenu">Gathering</router-link>
                                            <router-link to="Lore" v-on:click.native="showMenu = !showMenu">Lore</router-link>
                                            <router-link to="Perks" v-on:click.native="showMenu = !showMenu">Perks</router-link>
                                            <router-link to="Faq" v-on:click.native="showMenu = !showMenu">FAQ</router-link>
                                        </div>
                                    </li>
                                    <li class="plain-link dropdown"><a>Community</a>
                                        <div class="dropdown-content">
                                            <li><a href="https://discord.gg/qJfYhJ8" @click="showMenu = !showMenu" target="_blank">Discord</a></li>  
                                            <router-link to="InGame" v-on:click.native="showMenu = !showMenu">In Game</router-link>
                                        </div>
                                    </li>
                                    <li class="plain-link dropdown"><a>Media</a>
                                        <div class="dropdown-content">
                                            <router-link to="Wallpapers" v-on:click.native="showMenu = !showMenu">Wallpapers</router-link>
                                            <a v-if="youtube_code" href="#" @click="openTrailer()">Trailer</a>
                                        </div>
                                    </li>
                                    <li class="plain-link"><router-link to="Store" v-on:click.native="showMenu = !showMenu">Store</router-link></li>
                                    <li class="plain-link"><router-link to="Team" v-on:click.native="showMenu = !showMenu">The Team</router-link></li>
                                    <li class="plain-link"><router-link to="Account" v-on:click.native="showMenu = !showMenu">My Account</router-link></li>
                                    <li class="plain-link"><a href="https://forums.embersadrift.com" @click="showMenu = !showMenu">Forums</a></li>                                
                                </ul>
                            </b-collapse>
                        </div>
                    </nav>
                    <div class="logo-vid-wrapper" v-if="animateLogo">
                        <video disablePictureInPicture autoplay muted loop id="emberVideo" class="logo-vid">
                            <source src="https://downloads.embersadrift.com/logo-loop.mp4" type="video/mp4">
                        </video>
                        <div v-if="youtube_code" class="logo-vid-overlay">
                            <div style="position: relative; left: -50%;">
                                <button class="outline-btn" style="z-index: 100; position: relative; top: 100;" @click="openTrailer()"> Watch the Official Trailer</button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="big-logo-wrapper">
                        <h1>
                            <img onload="this.style.opacity='1';" class="big-logo" src="@/assets/img/Embers-Logo.png" alt="Embers Adrift">
                        </h1>
                    </div>
                </header>
            </div>
            <!-- ============== DIVIDER ============== -->
            <div class="Divider">
                <hr class="Divider-rule">
            </div>
            <!--- Router -->
            <router-view></router-view>

            <!-- ============== DIVIDER ============== -->
            <div class="Divider">
                <hr class="Divider-rule">
            </div>
            <!-- ============== FOOTER =============== -->
            <div class="row pattern-dark">
                <footer class="container footer">
                    <div class="row">
                        <h2>Ignite Your Adventure</h2>
                    </div>
                    <div class="row" style="padding-top: 2rem">
                        <div class="col-xs-12 col-sm-6">
                            <nav class="footer-nav">
                                <ul>
                                    <li><a href="https://stormhavenstudios.com/#/terms-of-service" target="_blank">Terms of Service</a></li>
                                    <li><a href="https://stormhavenstudios.com/#/privacy-policy" target="_blank">Privacy Policy</a></li>
                                    <li><router-link to="Team">Contact</router-link></li>
                                    <li><router-link to="Press">Press Kit</router-link></li>
                                </ul>
                            </nav>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <nav class="social-nav">
                                <a href="https://www.facebook.com/EmbersAdrift"><span class="ion-social-facebook"></span></a>
                                <a href="https://twitter.com/EmbersAdrift"><span class="ion-social-twitter"></span></a>
                                <a href="https://www.youtube.com/c/EmbersAdrift"><span class="ion-social-youtube"></span></a>
                                <a href="https://www.twitch.tv/embersadrift"><span class="ion-social-twitch"></span></a>
                                <a href="https://www.instagram.com/embersadrift/"><span class="ion-social-instagram"></span></a>
                                <a href="https://www.pinterest.com/embersadrift"><span class="ion-social-pinterest"></span></a>
                            </nav>
                        </div>
                    </div>
                    <div class="row">
                        <p class="copyright">Copyright &copy; {{ new Date().getFullYear() }} by <a href="https://www.stormhavenstudios.com" target="_blank" alt="Stormhaven Studios">Stormhaven Studios LLC.</a></p>
                        <p class="trademark">Embers Adrift, and Ignite Your Adventure<br />are registered Trademarks of Stormhaven Studios, LLC.</p>
                    </div>
                    <cookie-law theme="embers">
                        <div slot="message">
                            We use cookies on our websites to enhance your experience, for analytics and to show you offers tailored to your interests.<br />
                            We may share your information with our advertising and analytics partners.<br />
                            For more information please see our <a href="https://stormhavenstudios.com/#/privacy-policy" target="_blank">Privacy Policy</a>
                        </div>
                    </cookie-law>
                </footer>
            </div>
            <b-modal ref="trailer-modal" hide-footer hide-header centered content-class="modal-content" size="wide">
                <span class="Video-border Video-border--top"></span>
                <span class="Video-border Video-border--right"></span>
                <span class="Video-border Video-border--bottom"></span>
                <span class="Video-border Video-border--left"></span>
                <span class="Video-corner Video-corner--topLeft"></span>
                <span class="Video-corner Video-corner--topRight"></span>
                <span class="Video-corner Video-corner--bottomRight"></span>
                <span class="Video-corner Video-corner--bottomLeft"></span>
            
                <div class="modal-body pattern-dark clearfix" id="modalBody">
                    <iframe id="TrailerView" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" :src="'https://www.youtube.com/embed/' + youtube_code + '?autohide=0&amp;autoplay=1&amp;branding=0&amp;cc_load_policy=0&amp;fs=1&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;quality=hd720&amp;rel=0&amp;showinfo=0&amp;wmode=opaque&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fembersadrift.com&amp;widgetid=3'" frameborder="0"></iframe>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import CookieLaw from 'vue-cookie-law';

    export default {
        name: 'MainRegion',
        components: { CookieLaw },
        data() {
            return {
                animateLogo: this.$route.meta.animateLogo,
                showMenu: false,
                maintMode: this.$config.maint_mode,
                youtube_code: this.$config.youtube_code
            }
        },
        watch:{
            '$route' () {
                this.animateLogo = this.$route.meta.animateLogo;
            },
            '$config' () {
                this.maintMode = this.$config.maint_mode;
                this.youtube_code = this.$config.youtube_code;
            }
        },
        methods: {
            openTrailer() {
                this.$refs['trailer-modal'].show();
            },
            closeTrailer() {
                this.$refs['trailer-modal'].hide();
            },
        } 
    }
</script>
